import React, { Component } from "react";
import { Form, List, Message, Segment } from "semantic-ui-react";

import request from "../../../utils/request";

class Details extends Component {
  constructor(props) {
    super(props);
    let winner = this.props.winner;

    // Bind function to refresh parent
    this.init = this.props.init;

    this.state = {
      id: winner.id,
      event_id: winner.event_id,
      prize: winner.prize,
      pay_reference: winner.reference !== null ? winner.reference : "",
      first_name: winner.first_name !== null ? winner.first_name : "",
      last_name: winner.last_name !== null ? winner.last_name : "",
      email: winner.email !== null ? winner.email : "",
      phone: winner.phone !== null ? winner.phone : "",
      claimed: winner.claimed,
      form_submitted: winner.form_submitted,
      check_written: winner.check_written,
      publish_winners_name: winner.publish_winners_name,
      notes: winner.notes !== null ? winner.notes : "",
      isLoading: false,
      xhrResponse: {
        success: null,
        message: ""
      },
    };
  }
  handleChange = (e, { name, value }) => this.setState({ [name]: value });
  handleBlur = (e) => {
    // Handle case where last character is missed in handleChange
    this.setState({ [e.target.name]: e.target.value });
  };
  handleSubmit = () => {
    this.setState({ isLoading: true });
    let payload = { ...this.state };
    delete payload["id"]; // Remove id from payload
    delete payload["event_id"]; // Remove event_id from payload
    delete payload["xhrResponse"]; // Remove xhrResponse from payload
    delete payload["isLoading"]; // Remove isLoading from payload
    delete payload["pay_reference"]; // Remove pay_reference from payload
    delete payload["prize"]; // Remove prize from payload

    request.put(this, `api:/event/${this.state.event_id}/winners/${this.state.id}`, payload).then(resp => {
      this.setState({
        xhrResponse: resp,
        isLoading: false
      }, () => this.props.init());
    });
  };
  render() {
    const {
      pay_reference,// TODO: turn into link(e.g https://storefrontURL.myshopify.com/admin/orders/ + refNumHere)
      first_name,
      last_name,
      email,
      phone,
      claimed,
      form_submitted,
      check_written,
      publish_winners_name,
      notes,
      isLoading,
      xhrResponse
    } = this.state;
    return (
      <Form
        as={Segment}
        basic
        loading={isLoading}
        success={xhrResponse.success === true}
        error={!xhrResponse.success && xhrResponse.success !== null}
      >
        <Message success content={xhrResponse.message} />
        <Message error content={xhrResponse.message} />
        <List divided verticalAlign='middle'>
          { pay_reference !== "" && (
              <List.Item>
                <List.Header>Reference :</List.Header>
                <List.Description>{pay_reference}</List.Description>
              </List.Item>
          )}
        </List>
        <Form.Group widths="equal">
          <Form.Input
            name="first_name"
            label="First Name"
            placeholder="First Name"
            value={first_name}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
          />
          <Form.Input
            name="last_name"
            label="Last Name"
            placeholder="Last Name"
            value={last_name}
            onChange={this.handleChange}
          />
          <Form.Input
            name="email"
            label="Email"
            placeholder="Email"
            value={email}
            onChange={this.handleChange}
          />
          <Form.Input
            name="phone"
            label="Phone Number"
            placeholder="Phone Number"
            value={phone}
            onChange={this.handleChange}
          />
        </Form.Group>
        <Form.Group inline>
          <label>Claimed</label>
          <Form.Radio
            name="claimed"
            label="Yes"
            value="1"
            checked={+claimed !== 0}
            onChange={this.handleChange}
          />
          <Form.Radio
            name="claimed"
            label="No"
            value="0"
            checked={+claimed === 0}
            onChange={this.handleChange}
          />
        </Form.Group>
        <Form.Group inline>
          <label>Publish Winner's Name</label>
          <Form.Radio
            name="publish_winners_name"
            label="Yes"
            value="1"
            checked={+publish_winners_name !== 0}
            onChange={this.handleChange}
          />
          <Form.Radio
            name="publish_winners_name"
            label="No"
            value="0"
            checked={+publish_winners_name === 0}
            onChange={this.handleChange}
          />
        </Form.Group>
        <Form.Group inline>
          <label>Prize Awarded</label>
          <Form.Radio
            name="check_written"
            label="Yes"
            value="1"
            checked={+check_written !== 0}
            onChange={this.handleChange}
          />
          <Form.Radio
            name="check_written"
            label="No"
            value="0"
            checked={+check_written === 0}
            onChange={this.handleChange}
          />
        </Form.Group>
        <Form.Group inline>
          <label>Form Submitted</label>
          <Form.Radio
            name="form_submitted"
            label="Yes"
            value="1"
            checked={+form_submitted !== 0}
            onChange={this.handleChange}
          />
          <Form.Radio
            name="form_submitted"
            label="No"
            value="0"
            checked={+form_submitted === 0}
            onChange={this.handleChange}
          />
        </Form.Group>
        <Form.Input
          name="notes"
          label="Notes"
          placeholder="Notes"
          value={notes}
          onChange={this.handleChange}
        />
        <Form.Button
          primary
          icon="save"
          content="Save"
          onClick={this.handleSubmit}
        />
      </Form>
    );
  }
}

export default Details;
